<template>
  <label-description-toggle
    v-if="hasMxaCampaignOptions"
    :disabled="hasCampaignBeenLaunched"
    :value="
      onceEver
        ? model.enter_journey_once_ever
        : model.enter_journey_once_at_a_time
    "
    :label-text="
      onceEver
        ? $t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Title')
        : $t(
            'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Title'
          )
    "
    :description-text="
      onceEver
        ? $t(
            'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Description'
          )
        : $t(
            'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Description'
          )
    "
    :info-icon="true"
    :tooltip-content="
      onceEver
        ? $t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Ever_Tooltip')
        : $t(
            'CampaignForm_Schedule_Journey_Frequency_Toggle_Once_At_A_Time_Tooltip'
          )
    "
    size="medium"
    style="margin-top: 20px"
    @change="onToggleChange($event)"
    :disabled-reason-tooltip="
      $t('CampaignForm_Schedule_Journey_Frequency_Toggle_Once_Disabled_Reason')
    "
  />
</template>

<script>
import LabelDescriptionToggle from '@/common/components/form/LabelDescriptionToggle'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'JourneyOptionEnterOnce',

  components: {
    LabelDescriptionToggle
  },

  props: {
    model: {
      type: Object
    },
    onceEver: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    onToggleChange(value) {
      if (this.onceEver) {
        this.model.enter_journey_once_ever = value
      } else {
        this.model.enter_journey_once_at_a_time = value
      }
    }
  },
  computed: {
    hasMxaCampaignOptions() {
      return $hasFeature('mxaCampaignOptions')
    },
    hasCampaignBeenLaunched() {
      return (
        this.model.id &&
        this.model.id > 0 &&
        !this.model.draft &&
        !this.model.is_campaign_template
      )
    }
  }
}
</script>
<style scoped>
>>> .label-ct {
  width: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/JourneyOptionEnterOnce.vue